import { createClient } from '@supabase/supabase-js';

// The publishable key is designed to be public: it ships in the browser bundle,
// and Row Level Security on each table decides what it can read or write.
// NEVER put the service_role / secret (sb_secret_...) key in this website.
const SUPABASE_URL = 'https://ljumoqywmjdjqamsjgdg.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_P0M3ntY2mAvXJ_4CDZonDg__2mvO41n';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  // The website never signs anyone in, so don't keep or refresh sessions
  auth: { persistSession: false, autoRefreshToken: false },
});
